import React, {useState, useEffect} from 'react';

import {isEmpty} from "../../utils/validations";
import {getAllArticles} from "../../knowledgeBank/KnowledgeBankAction";

import ArticleView from "./ArticleView";

const Article = (props) => {
    const [articleState, setArticleState] = useState({
        articles: [],
        isApiInProgress: false,
        apiErrorMessage: '',
        open: false,
        vertical: 'top',
        horizontal: 'right',
    });

    useEffect(() => {
        getArticles();
    }, []);

    const handleClick = (newState) => () => {
        setArticleState(prevState => ({
            ...prevState,
            ...newState,
            open: true,
        }));
    };

    const handleClose = () => {
        setArticleState(prevState => ({
            ...prevState,
            open: false,
        }));
    };

    const copyToClipboard = (url) => {
        navigator.clipboard.writeText(url)
            .then(
                handleClick({vertical: 'top', horizontal: 'right'})
            )
            .catch(err => {
                console.error('Error copying text: ', err);
            });
    };

    const getArticles = () => {
        setArticleState(prevState => ({
            ...prevState,
            isApiInProgress: true,
        }));
        getAllArticles()
            .then(res => {
                if (res.success) {
                    setArticleState(prevState => ({
                        ...prevState,
                        isApiInProgress: false,
                        articles: (isEmpty(res.data) || isEmpty(res.data.articles)) ? [] : res.data.articles,
                    }));
                } else {
                    setArticleState(prevState => ({
                        ...prevState,
                        isApiInProgress: false,
                        apiErrorMessage: res.__error,
                    }));
                }
            });
    };

    return (
        <ArticleView
            {...props}
            {...articleState}
            handleClose={handleClose}
            copyToClipboard={copyToClipboard}
        />
    );
};

export default Article;